import React, { useState } from 'react';
import { SiteSection, SiteSectionHeader } from '../../../../components/site';
import { firmwareChips } from '../data';
import type { PlatformSubpageConfig } from '../types';

type ChipKey = keyof typeof firmwareChips;

export const FirmwareSdkContent: React.FC<{ config: PlatformSubpageConfig }> = ({ config }) => {
  const [chip, setChip] = useState<ChipKey>('esp32');
  const current = firmwareChips[chip];

  return (
    <SiteSection className="platform-sub-interactive">
      <SiteSectionHeader
        eyebrow="INTERACTIVE"
        title={config.sections.title}
        subtitle={config.sections.subtitle}
        align="center"
      />
      <div className="platform-sub-chip-row" role="group" aria-label="Select chipset">
        {(Object.keys(firmwareChips) as ChipKey[]).map((key) => (
          <button
            key={key}
            type="button"
            className={`platform-sub-chip${chip === key ? ' platform-sub-chip--active' : ''}`}
            aria-pressed={chip === key}
            onClick={() => setChip(key)}
          >
            {firmwareChips[key].label}
          </button>
        ))}
      </div>
      <div className="platform-sub-panel__grid">
        <ul className="platform-sub-chip-features">
          {current.features.map((f) => (
            <li key={f}>{f}</li>
          ))}
        </ul>
        <pre className="platform-sub-code">
          <code>{current.code}</code>
        </pre>
      </div>
    </SiteSection>
  );
};
